import React, { Component } from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
// import GithubRepoCard from "../../components/githubRepoCard/GithubRepoCard";
// import PublicationCard from "../../components/publicationsCard/PublicationCard";
// import Button from "../../components/button/Button";
import TopButton from "../../components/topButton/TopButton";
import { Fade } from "react-reveal";
// import {
//   greeting,
//   projectsHeader,
//   publicationsHeader,
//   publications,
// } from "../../portfolio.js";
// import ProjectsData from "../../shared/opensource/projects.json";
// import "./Projects.css";
// import ProjectsImg from "./ProjectsImg";

import Project from "../../containers/projects/Projects";
// import Certifications from "../../containers/certifications/Certifications";
// import CompetitiveSites from "../../components/competitiveSites/CompetitiveSites";
// import EducationImg from "./EducationImg";
// import { competitiveSites } from "../../portfolio";
// import { certifications } from "../../portfolio";
import "./EducationComponent.css";

class Projects extends Component {
  render() {
    const theme = this.props.theme;
    return (
      <div className="education-main">
        <Header theme={this.props.theme} />
        <div className="basic-education">
          <Fade bottom duration={2000} distance="40px">
            <div className="heading-div">
              <div className="heading-img-div">
                <img
									src={require("../../assests/images/what_i_do.svg")}
									alt=""
								/>
                {/* <EducationImg theme={theme} /> */}
              </div>
              <div className="heading-text-div">
                <h1 className="heading-text" style={{ color: theme.text }}>
                  Projects
                </h1>
                <h3 className="heading-sub-text" style={{ color: theme.text }}>
                  Let's go through my projects!!
                </h3>
                {/* <CompetitiveSites logos={competitiveSites.competitiveSites} /> */}
              </div>
            </div>
          </Fade>
          <Project theme={this.props.theme} />
          {/* {certifications.certifications.length > 0 ? (
            <Certifications theme={this.props.theme} />
          ) : null} */}
        </div>
        <Footer theme={this.props.theme} />
        <TopButton theme={this.props.theme} />
      </div>
    );
  }
}

export default Projects;
